module.exports = __webpack_public_path__ + "static/media/p11.7e4d8b78.png";